import styled from 'styled-components'

import { PairIcon, PairTicker } from '@root/entities/pair/ui/common'

import type { PairModel } from '@root/entities/pair'
import type { ClassNameProps } from '@root/shared/react'

type ProfilePositionsTableCurrencyCellProps = {
  pair: PairModel
} & ClassNameProps

export const ProfilePositionsTableCurrencyCell: React.FC<
  ProfilePositionsTableCurrencyCellProps
> = ({ className, pair }) => (
  <Root className={className}>
    <PairIcon pair={pair} size={28} withPairPopover withGoogleLens={false} />
    <Ticker pair={pair} />
  </Root>
)

const Root = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  justify-content: start;
  gap: 8px;
  padding-inline: 0 4px;

  cursor: pointer;
`

const Ticker = styled(PairTicker)`
  font-size: 12px;
  font-weight: 500;

  cursor: pointer;
`
